import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  WhiteWrapper,
  Wrapper,
  BottomModal,
  Button,
} from "../../Common/styles.common";
import { strings } from "utils/constants/strings";
import Tooltip from "sushiweb/Tooltip";
import useVendorStore from "../../HomePage/useVendorStore";
import { Loader } from "../../Common/Loader";
import { 
  STATUS_BEGIN, 
  STATUS_DONE, 
  STATUS_FAIL, 
  SERVICE_PO_SOURCE_LIST_VIEW,
  ENTITY_TYPE_CREDIT_NOTE,
  ENTITY_TYPE_INVOICE,
  INVOICE_STATUS_APPROVED,
  INVOICE_STATUS_VERIFIED,
  INVOICE_STATUS_PENDING,
  INVOICE_STATUS_REJECTED,
  PO_STATUS
} from "utils/constants/others";
import InfiniteScroll from "react-infinite-scroll-component";
import ShowToast from "../../Common/Toast";
import BackButton from "../../Button/BackButton";
import {
  FilterBox,
  SearchBarContainer,
  SearchIcon,
  SearchBar,
  POCard,
  PONumber,
  Divider,
  POAmountText,
  TotalInvoiceText,
  DownloadLink,
  ButtonRow,
  ActionButton,
  TabContainer,
  StatusFilterButton,
  EntityCard,
  EntityNumber,
  EntitySubtextContainer,
  EntitySubtext,
  GreyContainer,
  HorizontalBlock,
  LeftBlock,
  RightBlock,
  AmountLabel,
  AmountValue,
  StatusBadge,
  PaymentText,
  PaymentInfoContainer,
  InfoIcon,
  ModalOption,
  RadioButton,
  EmptyState,
  ButtonText,
  ActionButtonText,
  RejectionReasonText,
  FilterStatusText,
  PaymentInfoContainerSpaced,
  PaymentTextNoMargin,
  StatusBadgeClickable,
  ModalOptionTop,
  ModalOptionBottom,
  WhiteButton,
  CloseButtonModal,
  ModalHeaderContainer,
  ModalHeaderTitle,
  ModalHeaderSubtitle,
  ModalContentBox,
  ModalContentTitle,
  ModalContentText,
} from "../styles.po";
import { api } from "../../../../network/network";
import { API_HOST_WMS } from "../../../../config/api.config";
import { APIendpoints } from "../../../../utils/constants/APIendpoints";

// Debounce hook
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const POCardComponent = ({
  po,
  onDownloadPO,
  onDownloadMIS,
  onUploadDocuments,
}) => {

  const getPoAmount = () => {
    if (po.purchase_order_amount) {
      const amountStr = po.purchase_order_amount.toString();
      const match = amountStr.match(/₹?([\d,]+\.?\d*)/);
      return match ? match[1] : po.purchase_order_amount;
    }
    return po.po_amount || 0;
  };

  const formatAmount = (amount) => {
    if (!amount) return "0.00";
    const numAmount = parseFloat(amount);
    return numAmount.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  return (
    <POCard>
      <PONumber>{po.purchase_order_number}</PONumber>
      <Divider />
      <POAmountText>
        <img
          src="/logos/amount_book_icon.png"
          alt="amount"
          height="40px"
          width="40px"
        />
        {strings.poAmount}: ₹{getPoAmount()}
      </POAmountText>
      {po.total_invoiced_amount > 0 && (
        <TotalInvoiceText>
          <img
            src="/logos/note_book_icon.png"
            alt="invoice"
            height="40px"
            width="40px"
          />
          ₹{formatAmount(po.total_invoiced_amount)} worth invoices uploaded
        </TotalInvoiceText>
      )}
      {po.credit_note_amount > 0 && (
        <TotalInvoiceText>
          <img
            src="/logos/note_book_icon.png"
            alt="credit note"
            height="40px"
            width="40px"
          />
          ₹{formatAmount(po.credit_note_amount)} worth credit notes uploaded
        </TotalInvoiceText>
      )}
      <DownloadLink onClick={() => onDownloadPO(po.purchase_order_doc)}>
        <img
          src="/logos/download_grey_icon.png"
          alt="download"
          height="40px"
          width="40px"
        />
        {strings.downloadPO}
      </DownloadLink>
      <Divider />
      <ButtonRow>
        <ActionButton onClick={() => onDownloadMIS(po)}>
          <img
            src="/logos/bill-statement.png"
            alt="bill"
            height="16px"
            width="16px"
          />
          <ButtonText>
            {strings.downloadMIS}
          </ButtonText>
        </ActionButton>
        <ActionButton primary onClick={() => onUploadDocuments(po)}>
          {strings.uploadDocuments}
        </ActionButton>
      </ButtonRow>
    </POCard>
  );
};

const EntityCardComponent = ({
  entity,
  onDownloadPO,
  onDownloadEntity,
  onShowRejectionReason,
}) => {
  const isCreditNote = entity.entity_type === ENTITY_TYPE_CREDIT_NOTE;
  const isInvoice = entity.entity_type === ENTITY_TYPE_INVOICE;
  const isRejected = entity.entity_status?.toLowerCase() === "rejected";

  return (
    <EntityCard>
      <EntityNumber>
        {isCreditNote ? "CN no." : "Inv no."} {entity.entity_number}
      </EntityNumber>
      <EntitySubtextContainer>
        <EntitySubtext>
          {isCreditNote ? "CN" : "Invoice"} uploaded for{" "}
          {entity.purchase_order_number}
        </EntitySubtext>
      </EntitySubtextContainer>

      <GreyContainer>
        <HorizontalBlock>
          <LeftBlock>
            <AmountValue>₹{entity.amount}</AmountValue>
            <AmountLabel>
              {isCreditNote ? "CN amount" : "Invoice amount"}
            </AmountLabel>
          </LeftBlock>

          <RightBlock>
            {entity?.entity_status.length > 0 && (
              <StatusBadgeClickable
                status={entity.entity_status}
                onClick={() => isRejected && onShowRejectionReason(entity)}
                clickable={isRejected}
              >
                {entity.entity_status}
              </StatusBadgeClickable>
            )}
          </RightBlock>
        </HorizontalBlock>

        {entity.payment_status && (
          <PaymentInfoContainerSpaced>
            <PaymentTextNoMargin>
              {entity.payment_status}
            </PaymentTextNoMargin>
            {entity.paid_amount !== undefined && entity.paid_amount !== null && entity.paid_amount !== "" && (
              <>
                
                <Tooltip label= {"Paid amount " + entity.paid_amount} position="top" appearance="light">
                 <InfoIcon>i</InfoIcon>
                </Tooltip>
              </>
            )}
          </PaymentInfoContainerSpaced>
        )}
      </GreyContainer>

      <Divider />

      <ButtonRow>
        <ActionButton onClick={() => onDownloadPO(entity.po_doc)}>
          <img
            src="/logos/bill-statement.png"
            alt="download"
            height="16px"
            width="16px"
          />
          <ActionButtonText>
            Download PO
          </ActionButtonText>
        </ActionButton>
        <ActionButton onClick={() => onDownloadEntity(entity.entity_doc)}>
          <img
            src="/logos/bill-statement.png"
            alt="bill"
            height="16px"
            width="16px"
          />
          <ActionButtonText>
            {isCreditNote ? "Download CN" : "Download Invoice"}
          </ActionButtonText>
        </ActionButton>
      </ButtonRow>

      {entity.reason && (
        <RejectionReasonText>
          Reason: {entity.reason}
        </RejectionReasonText>
      )}
    </EntityCard>
  );
};

const AllServicePOsView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchServicePurchaseOrders = useVendorStore(
    (state) => state.searchServicePurchaseOrders
  );
  const searchServicePurchaseOrdersStatus = useVendorStore(
    (state) => state.searchServicePurchaseOrdersStatus
  );
  const servicePurchaseOrders = useVendorStore(
    (state) => state.servicePurchaseOrders
  );
  const poEntities = useVendorStore((state) => state.poEntities);

  const outletId = window.localStorage.getItem("outlet_id");
  // Set default tab from location state if provided, otherwise default to 0
  const [activeTab, setActiveTab] = useState(location.state?.defaultTab || 0); // 0 = Pending Invoice, 1 = Invoice Uploaded
  const [showLoader, setShowLoader] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [showToast, setShowToast] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const [showInvoiceStatusModal, setShowInvoiceStatusModal] = useState(false);
  const [selectedInvoiceStatus, setSelectedInvoiceStatus] = useState("");
  const [tempInvoiceStatus, setTempInvoiceStatus] = useState("");
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [selectedRejectedEntity, setSelectedRejectedEntity] = useState(null);

  useEffect(() => {
    if (searchServicePurchaseOrdersStatus === STATUS_BEGIN) {
      setShowLoader(true);
    }
    if (searchServicePurchaseOrdersStatus === STATUS_DONE) {
      setShowLoader(false);
    }
    if (searchServicePurchaseOrdersStatus === STATUS_FAIL) {
      setShowLoader(false);
      setShowToast(true);
    }
  }, [searchServicePurchaseOrdersStatus]);

  const fetchPOs = useCallback(
    (page = 0, isFirstPage = true) => {
      const pageSize = 20;
      const baseParams = {
        vendor_id: parseInt(outletId),
        page_number: page * pageSize,
        page_size: pageSize,
      };

      if (debouncedSearchQuery) {
        baseParams.purchase_order_number = debouncedSearchQuery;
      }

      if (activeTab === 0) {
        // Pending Invoice tab
        baseParams.is_doc_uploaded = false;
        baseParams.purchase_order_status = PO_STATUS.APPROVED;
      } else {
        // Invoice Uploaded tab
        baseParams.is_doc_uploaded = true;

        // Add invoice status filter if selected
        if (selectedInvoiceStatus) {
          // Map VERIFIED to APPROVED for backend API
          baseParams.invoice_status = selectedInvoiceStatus === INVOICE_STATUS_VERIFIED ? INVOICE_STATUS_APPROVED : selectedInvoiceStatus;
        }
      }

      searchServicePurchaseOrders(baseParams, null, SERVICE_PO_SOURCE_LIST_VIEW, isFirstPage);
    },
    [
      activeTab,
      debouncedSearchQuery,
      selectedInvoiceStatus,
      outletId,
      searchServicePurchaseOrders,
    ]
  );

  useEffect(() => {
    setPageNumber(0);
    fetchPOs(0, true);
  }, [activeTab, debouncedSearchQuery, selectedInvoiceStatus]);

  const loadNextPage = () => {
    console.log("here i am geting called", "current page:", pageNumber)
    const nextPage = pageNumber + 1;
    setPageNumber(nextPage);
    fetchPOs(nextPage, false);
  };

  const handleDownloadPO = (poDocUrl) => {
    if (poDocUrl) {
      window.open(poDocUrl, "_blank");
    } 
  };

  const downloadMISFile = async (url, retryCount = 0) => {
    const maxRetries = 10;
    const retryInterval = 2000; // 2 seconds
    try {
      const fetchResult = await fetch(url);

      if (fetchResult.status !== 200) {
        if (retryCount < maxRetries) {
          setTimeout(() => downloadMISFile(url, retryCount + 1), retryInterval);
        } else {
          setShowLoader(false);
          setShowToast(true);
          setTimeout(() => setShowToast(false), 3000);
        }
      } else {
        // Download successful
        window.open(url, "_blank");
        setShowLoader(false);
      }
    } catch (error) {
      if (retryCount < maxRetries) {
        setTimeout(() => downloadMISFile(url, retryCount + 1), retryInterval);
      } else {
        setShowLoader(false);
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      }
    }
  };

  const handleDownloadMIS = async (po) => {
    try {
      setShowLoader(true);

      // Call the MIS download API with query params
      const response = await api.get(API_HOST_WMS, APIendpoints.downloadMIS, {
        query: {
          vendor_id: parseInt(outletId),
          po_number: po.purchase_order_number,
        },
      });

      // Check if response contains download URL
      if (response.data && response.data.response) {
        const downloadUrl = response.data.response.download_link;

        if (downloadUrl) {
          // Start download with retry logic
          downloadMISFile(downloadUrl, 0);
        } else {
          setShowLoader(false);
        }
      } else {
        setShowLoader(false);
      }
    } catch (error) {
      setShowLoader(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  const handleUploadDocuments = (po) => {
    navigate(`/upload-documents/${po.purchase_order_number}`);
  };

  const handleDownloadEntity = (entityDocUrl) => {
    if (entityDocUrl) {
      window.open(entityDocUrl, "_blank");
    } 
  };

  const handleInvoiceStatusConfirm = () => {
    setSelectedInvoiceStatus(tempInvoiceStatus);
    setShowInvoiceStatusModal(false);
  };

  const handleInvoiceStatusModalOpen = () => {
    setTempInvoiceStatus(selectedInvoiceStatus);
    setShowInvoiceStatusModal(true);
  };

  const handleShowRejectionReason = (entity) => {
    setSelectedRejectedEntity(entity);
    setShowRejectionModal(true);
  };

  const handleDownloadPendingPayments = async () => {
    try {
      setShowLoader(true);

      const response = await api.get(
        API_HOST_WMS,
        APIendpoints.downloadPendingPayments,
        {
          query: {
            vendor_id: parseInt(outletId),
          },
        }
      );

      if (
        response.data &&
        response.data.response &&
        response.data.response.presigned_url
      ) {
        const presignedUrl = response.data.response.presigned_url;
        window.open(presignedUrl, "_blank");
      } else {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 3000);
      }

      setShowLoader(false);
    } catch (error) {
      setShowLoader(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }
  };

  const renderCards = () => {
    if (activeTab === 0) {
      // Pending Invoice tab - show PO cards
      if (!servicePurchaseOrders || servicePurchaseOrders.length === 0) {
        return (
          <EmptyState>
            No purchase orders found
          </EmptyState>
        );
      }

      return servicePurchaseOrders.map((po, index) => (
        <POCardComponent
          key={po.id || index}
          po={po}
          onDownloadPO={handleDownloadPO}
          onDownloadMIS={handleDownloadMIS}
          onUploadDocuments={handleUploadDocuments}
        />
      ));
    } else {
      // Invoice Uploaded tab - show entity cards
      if (!poEntities || poEntities.length === 0) {
        return (
          <EmptyState>
            No entities found
          </EmptyState>
        );
      }

      return poEntities.map((entity, index) => (
        <EntityCardComponent
          key={entity.entity_number || index}
          entity={entity}
          onDownloadPO={handleDownloadPO}
          onDownloadEntity={handleDownloadEntity}
          onShowRejectionReason={handleShowRejectionReason}
        />
      ));
    }
  };

  return (
    <React.Fragment>
      <Wrapper>
        <WhiteWrapper>
          <div className="d-flex align-items-center">
            <BackButton pathName={"/"} />
            <span className="fs-16 fw-600">{strings.allPOsHeader}</span>
          </div>
        </WhiteWrapper>

        <div className="p-4">
          <SearchBarContainer>
            <SearchIcon src="/logos/search-icon.svg" alt="search" />
            <SearchBar
              type="text"
              placeholder={strings.searchByPO}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </SearchBarContainer>
        </div>

        <TabContainer>
          <FilterBox
            clicked={activeTab === 0}
            onClick={() => setActiveTab(0)}
            className="fs-13 fw-500"
          >
            {strings.pendingInvoiceTab}
          </FilterBox>
          <FilterBox
            clicked={activeTab === 1}
            onClick={() => setActiveTab(1)}
            className="fs-13 fw-500"
          >
            {strings.invoiceUploadedTab}
          </FilterBox>
        </TabContainer>

        {activeTab === 1 && (
          <TabContainer>
            <StatusFilterButton onClick={handleInvoiceStatusModalOpen}>
              <img
                src="/logos/filter-thick.png"
                alt="filter"
                height="14px"
                width="14px"
              />
              <FilterStatusText>
                Invoice Status{" "}
                {selectedInvoiceStatus && `(${selectedInvoiceStatus})`}
              </FilterStatusText>
              <img
                src="/logos/chevron-down-large.svg"
                alt="dropdown"
                height="10px"
                width="10px"
              />
            </StatusFilterButton>
          </TabContainer>
        )}

        {showLoader && pageNumber === 0 ? (
          <Loader />
        ) : (
          console.log("Rendering Infinite Scroll"),
          <InfiniteScroll
            className="infinite-scroll"
            height={"calc(100vh - 250px)"}
            dataLength={
              activeTab === 0
                ? servicePurchaseOrders?.length || 0
                : poEntities?.length || 0
            }
            hasMore={true}
            next={loadNextPage}
            loader={<Loader isScrollLoader={true} />}
          >
            {renderCards()}
          </InfiniteScroll>
        )}

        {/* Invoice Status Filter Modal */}
        <BottomModal
          visible={showInvoiceStatusModal}
          onClose={() => setShowInvoiceStatusModal(false)}
        >
          <div className="p-4">
            <ModalOptionTop
              selected={tempInvoiceStatus === ""}
              onClick={() => setTempInvoiceStatus("")}
            >
              <span>All Statuses</span>
              <RadioButton selected={tempInvoiceStatus === ""} />
            </ModalOptionTop>

            <ModalOption
              selected={tempInvoiceStatus === INVOICE_STATUS_PENDING}
              onClick={() => setTempInvoiceStatus(INVOICE_STATUS_PENDING)}
            >
              <span>Pending</span>
              <RadioButton selected={tempInvoiceStatus === INVOICE_STATUS_PENDING} />
            </ModalOption>

            <ModalOption
              selected={tempInvoiceStatus === INVOICE_STATUS_REJECTED}
              onClick={() => setTempInvoiceStatus(INVOICE_STATUS_REJECTED)}
            >
              <span>Rejected</span>
              <RadioButton selected={tempInvoiceStatus === INVOICE_STATUS_REJECTED} />
            </ModalOption>

            <ModalOptionBottom
              selected={tempInvoiceStatus === INVOICE_STATUS_VERIFIED}
              onClick={() => setTempInvoiceStatus(INVOICE_STATUS_VERIFIED)}
            >
              <span>Verified</span>
              <RadioButton selected={tempInvoiceStatus === INVOICE_STATUS_VERIFIED} />
            </ModalOptionBottom>

            <Button
              className="fs-14 fw-600 mt-4 w-100"
              onClick={handleInvoiceStatusConfirm}
            >
              Confirm
            </Button>
          </div>
        </BottomModal>

        {/* Rejection Reason Modal */}
        <BottomModal
          visible={showRejectionModal}
          onClose={() => setShowRejectionModal(false)}
        >
          <div className="p-4">
            <ModalHeaderContainer>
              <div>
                <ModalHeaderTitle>
                  {selectedRejectedEntity?.entity_type === ENTITY_TYPE_CREDIT_NOTE
                    ? "CN. No."
                    : "Inv. No."}{" "}
                  {selectedRejectedEntity?.entity_number}
                </ModalHeaderTitle>
                <ModalHeaderSubtitle>
                  {selectedRejectedEntity?.entity_type === ENTITY_TYPE_CREDIT_NOTE
                    ? "Credit Note"
                    : "Invoice"}{" "}
                  uploaded for {selectedRejectedEntity?.purchase_order_number}
                </ModalHeaderSubtitle>
              </div>
              <CloseButtonModal
                onClick={() => setShowRejectionModal(false)}
              >
                ×
              </CloseButtonModal>
            </ModalHeaderContainer>

            <ModalContentBox>
              <ModalContentTitle>
                Invoice rejection reason
              </ModalContentTitle>
              <ModalContentText>
                {selectedRejectedEntity?.reason || "No reason provided"}
              </ModalContentText>
            </ModalContentBox>

            {selectedRejectedEntity?.entity_type === ENTITY_TYPE_INVOICE && (
              <Button
                className="fs-14 fw-600 mt-4 w-100"
                onClick={() => {
                  setShowRejectionModal(false);
                  navigate(
                    `/upload-documents/${selectedRejectedEntity?.purchase_order_number}`
                  );
                }}
              >
                Upload correct invoice
              </Button>
            )}
          </div>
        </BottomModal>
      </Wrapper>
    </React.Fragment>
  );
};

export default AllServicePOsView;
